// extracted by mini-css-extract-plugin
module.exports = {"Container":"Nav_Container__3OT2C","List":"Nav_List__-SYNZ","Tab":"Nav_Tab__2zKOe","ActiveTab":"Nav_ActiveTab__XrmWK","Label":"Nav_Label__3rS2M"};